// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"77ef0f56","59":"77ef0f56","539":"77ef0f56","905":"77ef0f56"}[chunkId] + ".chunk.css";
};